import { Injectable } from "@angular/core";
import { setCookie } from "app/common/utils/cookie.util";
import { environment } from "environments/environment";
import { LoginWithEmailOTPEvents, Magic } from 'magic-sdk';
import { Subject, from, switchMap, of, reduce, Observable, ReplaySubject, BehaviorSubject } from "rxjs";
import { AuthService } from "../../auth/auth.service";
import { ContractsService } from "../../contract/contracts.service";
import { SpinnerService } from "../../spinner/spinner.service";
import { UserService } from "../../user/user.service";
import { MagicWrapperService } from "./magic-wrapper.service";
import { eProviders, Web3Service } from "../../web3/web3.service";

@Injectable({
    providedIn: 'root'
})

export class MagicService {

    // private magicLoginWithEMailOTP: Subject<any> = new Subject<any>();
    // loggedSuccessfully: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);
    loggedSuccessfully: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);


    constructor(
        private web3Service: Web3Service,
        private spinnerService: SpinnerService,
        private contractsService: ContractsService,
        private magicWrapperService: MagicWrapperService
    ) { }
    // async login(email: string, loginResponse) {
    //     /* One-liner login with email OTP 🤯 */
    //     this.spinnerService.setSpinner(true);
    //     let missingWallet: boolean = !loginResponse.walletAddress ? true : false;
    //     await magicLink.auth.loginWithEmailOTP({ email });
    //     /* magicLink.auth.loginWithEmailOTP({ email }).then(
    //         value => this.magicLoginWithEMailOTP.next(value),
    //         error => console.log(error)
    //     ) */

    //     const isLoggedIn = await magicLink.user.isLoggedIn();

    //     if (isLoggedIn) {
    //         this.contractService.disconnectProviderWeb3();
    //         this.contractService.mountMagic().then((data) => {
    //             if (data == undefined) {
    //                 this.contractService.getAccounts().then(() => {
    //                     // console.log(this.accounts)
    //                     if (missingWallet) {
    //                         this.web3Service.linkWalletPlayFab("magic")
    //                     } else {
    //                         // this.contractService.getKryptomons('magic');
    //                         this.spinnerService.setSpinner(false);//TO REMOVE?
    //                         this.authService.setAuthentication(true, { cookieKey: 'login', cookieValue: 'magic', days: 30 });
    //                         this.authService.routeAfterSuccessfulLogin(loginResponse);
    //                     }
    //                 })
    //             } else {
    //                 this.spinnerService.setSpinner(false);
    //                 // this.isLoading = false;
    //                 // this.toastr.error('Try again, or contact our team for support-lm1', 'Ops! Something went wrong', { timeOut: 5000 });

    //             }
    //         })
    //     } else {
    //         // this.toastr.error('Try again, or contact our team for support-lm2', 'Ops! Something went wrong', { timeOut: 5000 });
    //         // this.isLoading = false;
    //         this.spinnerService.setSpinner(false);
    //     }
    // }

    login(email, isWalletMissing: boolean/* , callback: () => void */) {
        /* One-liner login with email OTP 🤯 */
        // this.magicWrapperService.loginWithEmailOTP(email).pipe(
        //     switchMap(_ => this.magicWrapperService.isLoggedIn().pipe(
        //         switchMap(isLoggedIn => {
        //             if (isLoggedIn) {
        //                 return this.magicWrapperService.getWeb3Magic();
        //             } else return of(false);
        //         })
        //     ))
        // )
        this.spinnerService.setSpinner(true);
        let that = this;

        this.magicWrapperService.loginWithEmailOTP(email).subscribe({
            next: _ => that.magicWrapperService.isLoggedIn().subscribe({
                next: isLoggedIn => {
                    if (isLoggedIn) {
                        // let isMagicSet: boolean = that.setMagicWeb3();
                        let web3 = this.magicWrapperService.getWeb3Magic();
                        if (web3?.eth) {
                            that.web3Service.setWeb3(web3);
                            that.web3Service.getChainId().subscribe(netId => {
                                that.web3Service.mountWallet(netId);
                                // that.mountMagic();
                                if (!isWalletMissing) {
                                    that.loggedSuccessfully.next(true);
                                    /* callback(); */
                                }
                                else that.web3Service.linkWalletPlayFab(eProviders.magic/* , () => callback() */);
                            })
                        } else {
                            console.log('Try again, or contact our team for support-lm1');
                        }
                    }
                }
            }
            ),
            error: err => { this.spinnerService.setSpinner(false); console.log('error LoginWIthEmailOTP', err) },
            complete: () => this.spinnerService.setSpinner(false)
        }
        );

    }

    // setMagicWeb3(): boolean {
    //     let web3 = this.magicWrapperService.getWeb3Magic();
    //     if (web3) {
    //         this.web3Service.setWeb3(web3)
    //     };
    //     return web3?.eth ? true : false;
    // }

    //deprecated
    mountMagic(): void {
        let web3 = this.magicWrapperService.getWeb3Magic();
        // this.web3Service.setWeb3(web3);
        // if (web3?.eth) {
        web3.currentProvider.on('accountChanged', (account) => {
            //TODO disconnectProvider()
            console.log(`disconnect ${account}`)
        });
        web3.currentProvider.on('networkChanged', (account) => {
            //TODO ???
            // location.reload();
        });
        ////if getChainID were an observbable
        // this.web3Service.getChainId(web3).subscribe(
        //     netId => {
        //         let _networkName = networkName[netId.toString()];
        //         this.contractsService.setContractInstancesByNetwork(web3, _networkName);
        //     }
        // )
        // let netId = this.web3Service.getChainId();
        // let _networkName = networkName[netId.toString()];
        // this.contractsService.setContractInstancesByNetwork(web3, _networkName);
        //     return true;
        // } else false;
    }


}